export const AGATHA_PAGE_SEARCH_FORM_ID = 'agatha-page-search-form-id';

export const GLOBAL_NAV_SEARCH_FORM_ID = 'global-nav-search-form-id';

export const MAX_NUMBER_OF_RECENT_SEARCHES = 3;

export const TIME_DELAY_TO_FETCH_SUGGESTIONS = 50;

export const CLASSNAME_FOR_AGATHA_GENERATED_SUGGESTION = 'agatha-generated-suggestion';

export const CLASSNAME_FOR_JEEVES_GLOBAL_NAV_SUGGESTION = 'jeeves-global-nav-suggestion';

export const LANGUAGE_OPTIONS = {
  english: {
    languageCode: 'en',
    label: 'English'
  },
  spanish: {
    languageCode: 'es',
    label: 'Espa' + '\u00f1' + 'ol',
  }
};

export const MIN_GRADE_RANGE = 300;
export const MAX_GRADE_RANGE = 1260;

export const GRADE_MARKS = [
  {value: 300, label: '2'},
  {value: 360},
  {value: 420},
  {value: 480},
  {value: 540},
  {value: 600},
  {value: 660},
  {value: 720},
  {value: 780},
  {value: 840},
  {value: 900},
  {value: 960},
  {value: 1020},
  {value: 1080},
  {value: 1140},
  {value: 1200},
  {value: 1260, label: '12'},
];

export const LEXILE_GRADE_MAP = {
  300: {
    grade: 2,
    lexile: 300
  },
  360: {
    grade: 2,
    lexile: 360
  },
  420: {
    grade: 2,
    lexile: 420
  },
  480: {
    grade: 2,
    lexile: 480
  },
  540: {
    grade: 3,
    lexile: 540
  },
  600: {
    grade: 3,
    lexile: 600
  },
  660: {
    grade: 4,
    lexile: 660
  },
  720: {
    grade: 4,
    lexile: 720
  },
  780: {
    grade: 5,
    lexile: 780
  },
  840: {
    grade: 5,
    lexile: 840
  },
  900: {
    grade: 5,
    lexile: 900
  },
  960: {
    grade: 6,
    lexile: 960
  },
  1020: {
    grade: 7,
    lexile: 1020
  },
  1080: {
    grade: 7,
    lexile: 1080
  },
  1140: {
    grade: 8,
    lexile: 1140,
  },
  1200: {
    grade: '9-10',
    lexile: 1200
  },
  1260: {
    grade: '11-12',
    lexile: 1260
  },
};

export const ALL_CONTENT_TYPES_SELECTION_VALUE = 'all';

export const SUGGESTION_CATEGORIES = {
  ESSENTIAL_QUESTION: 'eq',
};

export const SUGGESTION_CATEGORY_LABELS = {
  [SUGGESTION_CATEGORIES.ESSENTIAL_QUESTION]: 'Essential question'
};
